<template>
  <div class="my-detail-wrap">
    <!-- <img src="../../assets/images/winter/back.png" alt=""> -->
    <Header :name="name" :type="type" />
    <div class="base">
      <div class="cont">
        <div class="row">
          <ul>
            <li class="flex-flex-start">
              <span class="big">{{ currentData.team_name || '' }}</span>
              <span class="flag" v-if="currentData.tag">{{ currentData.tag }}</span>
            </li>
            <li>
              <span class="small">{{ currentData.service_name || '' }}</span>
            </li>
          </ul>
        </div>
        <div class="flex-space-around-no popularity">
          <div class="flex-vertically-left-center">
            <img class="flames" src="../../assets/images/winterGame/flames1.png">
            <span>战队人气值：{{ currentData.team_popularity || 0 }}</span>
          </div>
          <div> <span>战区人气排名：{{ currentData.war_zone_rank || 0 }}</span></div>
        </div>
        <div class="group-performance">
          <div class="group-promotion">
            <img class="pic" src="../../assets/images/winterGame/help-upgrade.png" alt="">
            <div class="ranking">
              <div class="title">小组赛最好成绩</div>
              <div class="num">第{{ currentData.group_rank || 0 }}名</div>
            </div>
          </div>
          <div class="flex-space-around group-data">
            <div class="current-information">
              <div class="num">{{ currentData.all_score || 0 }}</div>
              <div class="text">战队赛季累计奖杯数</div>
            </div>
            <div class="current-information">
              <div class="num">{{ Math.round(Number(currentData.win_rate || 0) / 100) }}%</div>
              <div class="text">胜率</div>
            </div>
            <div class="current-information">
              <div class="num">{{ currentData.pk_count || 0 }}</div>
              <div class="text">PK局数</div>
            </div>
            <div class="current-information">
              <div class="num">{{ currentData.win_count || 0 }}/{{ currentData.loss_count || 0 }}/{{
                  currentData.flat_count
                  || 0
              }}</div>
              <div class="text"> 胜/负/平（空) </div>
            </div>
          </div>
        </div>
        <!--  -->
        <div class="share" @click="handleAssistance">
          <span>邀请助力支持</span>
        </div>
      </div>
      <div class="cont members">
        <div class="member">
          <div class="title">
            <div class="flex-vertically-left-center">
              <div class="information">战队成员</div>
              <div class="flex-vertically-left-center adjustment" @click="handleAdjustTrainees">
                <img src="../../assets/images/winter/members.png" />调整
              </div>
            </div>
            <div class="detailed" @click="handleViewDetails">查看详细数据 >></div>
          </div>
          <div class="line"></div>
          <studentTable :dataList="dataList" :headerList="headerList" :footer='false' />
        </div>
      </div>
    </div>
    <battalionPoster :posterUrl="posterUrl" ref="poster" :isShow="isShow" @OnCancelPoster="handleCancelPoster">
      <div id="container">
        <div class="poster-war-report" v-if="isPoster == 1">
          <img class="bac-pic" src="../../assets/images/winterGame/poster-bac4.png" />

          <div class="help-with-likes">
            <div class="server-center">{{ currentData.service_name || '' }}</div>
            <div class="battalion">
              <div class="name"> 我的战队 </div>
              <div class="title"> {{ currentData.team_name || '' }} </div>
              <div class="introduce"> 参加松鼠杯打基础冬季赛需要你的支持！ </div>
            </div>
          </div>
          <!-- 二维码 -->
          <div class="qr-code">
            <div class="code-bac">
              <img class="code-pic" :src="codeUrlImge" />
            </div>
            <div class="distinguish">
              <template v-if="isPoster == 5">
                <div>微信扫一扫识别二维码</div>
                <div>支持我的战队</div>
              </template>
              <template v-else>
                <div>识别二维码</div>
                <div>参加松鼠杯</div>
              </template>
            </div>
          </div>
        </div>
      </div>
    </battalionPoster>
  </div>
</template>

<script>
import { Toast } from "vant";
import html2canvas from "html2canvas";
import Header from '../../components/SquirrelCupII/battalionHeader'
import battalionPoster from "../../components/SquirrelCupII/battalion-poster";
import { agentMyTeam, qrCode } from "../../api/winterGame";
import { GetRequest } from "@/util/util"
import studentTable from '../../components/SquirrelCupII/student-data.vue'

export default {
  name: 'member-record',
  components: {
    Header,
    studentTable,
    battalionPoster
  },
  data() {
    return {
      name: '我的战队',
      type: 0,
      headerList: ['姓名', '学科', '奖杯数', '局数', '胜率'],
      isPoster: -1,
      posterUrl: '',
      codeUrlImge: '',
      isShow: false,
      dataPickerValue: '',
      showPicker: false,
      userInfoId: {},
      currentData: {},
      subActive: 1,
      servicePoint: {},
      todaySituation: {},
      dataList: {
        team_members: []
      }
    }
  },
  async created() {
    let { agentId, type } = this.$route.query || {}
    console.log(agentId)
    if (type && type == 1) {
      await localStorage.setItem('userInfoId', JSON.stringify({ agentId, openId: '' }))
      this.userInfoId = await JSON.parse(localStorage.getItem('userInfoId')) || {}
      this.type = Number(type) || 0
    } else {
      this.userInfoId = await JSON.parse(localStorage.getItem('userInfoId')) || {}
    }
    console.log(this.userInfoId)
    await this.getData()
    await this.onRecodeImage()
  },
  mounted() {

  },
  methods: {
    getData() {
      let { openId, agentId } = this.userInfoId || {};
      let params = {
        param: { openId, agentId }
      }
      agentMyTeam(params).then(res => {
        if (res.code === 0) {
          let { data } = res || {}
          this.currentData = res.data || {}
          this.dataList['team_members'] = data && data.team_members || []
        }
      })
    },
    // 调整学员
    handleAdjustTrainees() {
      window.wx.miniProgram.navigateTo({ url: '/subpackages/home/winterGame/addTeamMembers/index' })
    },
    // 查看详情
    handleViewDetails() {
      this.$router.push('/winterGame/memberRecord')
    },
    onConfirm(time) {
      this.dataPickerValue = time;
      this.showPicker = false;
    },
    handleCancelPoster(type) {
      this.isShow = type;
    },
    // 生成二维码
    async onRecodeImage(type) {
      const { codeUrl, userInfoId } = this || {}
      // let url = 'https://live-matches-h5-test.songshuai.com/#/like'
      let url = 'https://live-matches-h5.songshuai.com/#/like'  // userInfoId.agentId
      const urlZl = `${url}?serviceId=${userInfoId.agentId || 0}&followUserId=${userInfoId.agentUserId || 0}`;
      const params = { param: urlZl }
      await qrCode(params).then(res => {
        if (res.code === 0) {
          this.codeUrlImge = res.data || ''
        }
      })
      console.log('urlZl', urlZl)
    },
    // 助力
    async handleAssistance() {
      Toast.loading({ message: "加载中...", forbidClick: true, duration: 0 });
      this.isPoster = 1
      setTimeout(() => {
        const targetDom = document.querySelector("#container");
        const config = {
          useCORS: true,
          logging: true,
          width: targetDom.offsetWidth,
          height: targetDom.offsetHeight
        }
        html2canvas(targetDom, config).then((canvas) => {
          this.isShow = true;
          this.posterUrl = canvas.toDataURL();
          console.log(this.isPoster)
          Toast('长按保存图片');;
          // gio("track", "onShareBattleReport", { onSharePosters: "helpShare" });
        });
      }, 1000)


    }
  },
}
</script>

<style lang="less">
@import "../../assets/style/global.less";

.my-detail-wrap {
  position: relative;
  width: 100%;
  min-height: 100%;
  background: linear-gradient(180deg, #002455 0%, #001D46 100%);
  padding-bottom: 50px;

  .header {
    width: 100%;
    position: relative;

    .bac {
      display: block;
      width: 100%;
    }

    .back {
      position: absolute;
      top: 22px;
      left: 30px;
      width: 136px;
      height: 48px;
      cursor: pointer;

      img {
        display: block;
        width: 100%;
      }
    }

    .polygon {
      width: 240px;
      height: 66px;
      margin: 0 auto 0;
      font-size: 36px;
      color: #FFFFFF;
      height: 66px;
      text-align: center;
      position: absolute;
      left: 50%;
      bottom: 74px;
      transform: translate(-50%, 0);
      z-index: 1;

      .pic {
        width: 100%;
        position: absolute;
        top: 0;
        left: 0;
        z-index: -1;
      }

      .name {
        height: 100%;
      }
    }
  }

  .cont {
    position: relative;
    width: 686px;
    margin: -30px auto 0;
    background: #FFFFFF;
    border-radius: 8px;
    overflow: hidden;

    .row {
      padding: 30px;
      background: #8566FF linear-gradient(135deg, #1B94FF 0%, #23B0FF 100%);

      ul {

        // display: flex;
        // align-items: center;
        // justify-content: space-around;
        li {
          position: relative;

          &.line {
            width: 4px;
            border: 2px solid #EEEEEE;
          }

          span {
            display: inline-block;

            &.big {
              font-size: 36px;
              font-family: PingFangSC-Semibold, PingFang SC;
              font-weight: 600;
              color: #FFDE70;
              padding-right: 16px;
            }

            &.normal {
              font-size: 28px;
              font-family: PingFangSC-Medium, PingFang SC;
              font-weight: 500;
              color: #FFFFFF;
            }

            &.small {
              font-size: 24px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: #FFFFFF;
            }

            &.flag {
              background: #FFDE70;
              border-radius: 19px;
              padding: 5px 10px;
              color: #333333;
            }
          }
        }
      }
    }

    .share {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-bottom: 24px;

      span {
        display: block;
        background: linear-gradient(90deg, #4572F7 0%, #FF5AA8 100%);
        border-radius: 28px;
        font-size: 24px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #FFFFFF;
        text-align: center;
        padding: 12px 30px;

        &::before {
          display: inline-block;
          content: '';
          width: 24px;
          height: 24px;
          background: url("../../assets/images/winter/second/shareIcon.png") no-repeat center;
          background-size: 100%;
          vertical-align: middle;
          margin-right: 10px;
        }
      }
    }

    .line {
      width: 686px;
      height: 12px;
      margin-left: -30px;
      background: rgba(0, 71, 141, 0.1);
    }

    &.members {
      margin: 24px auto 0;

      .member {
        width: 100%;
        margin: 0 0 24px;

        .title {
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: 16px 32px;

          .information {
            font-size: 36px;
            font-weight: 600;
            color: #333333;
          }

          .adjustment {
            font-size: 22px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #2E9EFF;
            padding-left: 24px;

            img {
              display: block;
              width: 24px;
              margin-right: 4px;
            }
          }

          .detailed {
            font-size: 24px;
            font-weight: 400;
            color: #2E9EFF;
          }
        }


      }
    }

    .popularity {
      font-size: 24px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #2E9EFF;
      background: #D3EEFF;
      padding: 10px 0;

      .flames {
        display: block;
        width: 26px;
        margin-right: 4px;
      }
    }

    .group-performance {
      padding-top: 44px;
      padding-bottom: 24px;

      .group-promotion {
        position: relative;
        width: 450px;
        margin: 0 auto;

        .pic {
          display: block;
          width: 100%;
        }

        .ranking {
          text-align: center;
          position: absolute;
          left: 50%;
          bottom: 38px;
          transform: translate(-50%, 0);

          .title {
            font-size: 22px;
            font-weight: 500;
            color: #FFFFFF;
            padding-bottom: 4px;
          }

          .num {
            font-size: 36px;
            font-weight: 600;
            color: #815E00;
          }
        }
      }

      .group-data {
        padding: 0 50px;
        position: relative;

        &::after {
          content: '';
          position: absolute;
          width: 70%;
          height: 2px;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          background: #EEEEEE;
          z-index: 1;
        }

        &::before {
          content: '';
          position: absolute;
          width: 2px;
          height: 50%;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          background: #EEEEEE;
          z-index: 1;
        }

        .current-information {
          text-align: center;
          width: 50%;
          padding-top: 30px;

          .num {
            font-size: 36px;
            font-weight: 600;
            color: #333333;
            padding-bottom: 4px;
          }

          .text {
            font-size: 24px;
            font-weight: 400;
            color: #999999;
            height: 60px;
            margin: 0 auto;
          }
        }
      }
    }

    .w-170 {
      width: 170px;
    }

    .w-120 {
      width: 120px;
    }

    .w-100 {
      width: 100px;
    }

    .w-80 {
      width: 80px;
    }
  }

  //  海报
  #container {
    position: absolute;
    top: 0;
    left: 0;
    z-index: -1;

    .poster-war-report {
      // position: absolute;
      // top: 0;
      // left: 0;
      // z-index: 1;
      width: 100%;

      .bac-pic {
        width: 100%;
      }

      .help-with-likes {
        width: 90%;
        text-align: center;
        position: absolute;
        top: 17%;
        left: 50%;
        transform: translate(-50%, 0);

        .server-center {
          font-size: 32px;
          font-weight: 500;
          color: #ffffff;
          margin-top: 24px;
          min-height: 36px;
        }

        .battalion {
          padding-top: 660px;

          .name {
            font-size: 34px;
            font-weight: 600;
            color: #FFFFFF;
          }

          .title {
            font-size: 48px;
            font-weight: 500;
            color: #6dfffd;
            padding-bottom: 16px;
          }

          .introduce {
            font-size: 32px;
            font-weight: 500;
            color: #FFFFFF;
          }
        }
      }

      .qr-code {
        text-align: center;
        position: absolute;
        bottom: 114px;
        left: 50%;
        transform: translate(-50%, 0);

        .code-bac {
          width: 196px;
          height: 196px;
          border-radius: 2px;
          border: 8px solid #00ffff;
          margin: 0 auto;

          .code-pic {
            display: block;
            width: 100%;
            height: 100%;
            position: relative;
            z-index: 10;
          }
        }

        .distinguish {
          font-size: 24px;
          font-weight: 400;
          color: #ffffff;
          padding-top: 14px;
        }
      }
    }
  }
}
</style>
